import { http } from '@/lib/http'
import type { FeeEstimate, OnlinePaymentResponse, PaymentGroup, PaymentGroupKey, PaymentValidateResult, RentPaymentStatus, UpiDirectResponse } from '@/types/models'

export interface PayRentBody {
  leaseId: string
  /** rupees */
  amount: number
  group: PaymentGroupKey
  note?: string
  /** From the fee estimate; required for online groups. */
  feeToken?: string
}

/** Offline records return the transaction id as a bare string. */
export type PayRentResponse = OnlinePaymentResponse | UpiDirectResponse | string

export const paymentsApi = {
  groups: () => http.get<PaymentGroup[]>('/payments/rent/groups'),
  bankingStatus: (leaseId: string) => http.get<{ hasVerifiedBanking: boolean; hasVerifiedUpi: boolean }>('/payments/rent/banking-status', { params: { leaseId } }),
  /** Never compute fees client-side: this returns the breakdown and the token the payment needs. */
  feeEstimate: (leaseId: string, amount: number, group: PaymentGroupKey, propertyType?: string) =>
    http.get<FeeEstimate>('/payments/rent/fee-estimate', { params: { leaseId, amount: Math.round(amount), group, propertyType } }),
  payRent: (body: PayRentBody) => http.post<PayRentResponse>('/payments/rent', body),
  status: (transactionId: string) => http.get<RentPaymentStatus>(`/payments/${transactionId}/status`),
  validate: (transactionId: string) => http.get<PaymentValidateResult & { transactionId: string }>(`/payments/${transactionId}/validate`),
  cancel: (transactionId: string) => http.patch<null>(`/payments/${transactionId}/cancel`, {}),
  confirmUpi: (transactionId: string) => http.post<null>(`/payments/${transactionId}/confirm-upi`, {}),
  accept: (transactionId: string) => http.patch<null>(`/payments/${transactionId}/accept`, {}),
}

export const isUpiDirect = (r: PayRentResponse): r is UpiDirectResponse => typeof r === 'object' && r.gateway === 'upi_direct'
export const isOnline = (r: PayRentResponse): r is OnlinePaymentResponse => typeof r === 'object' && r.gateway !== 'upi_direct'
